import styled from 'styled-components'

export default styled.div`
  display: flex;
  height: auto;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
`
